import { render, staticRenderFns } from "./NumberAnimation.vue?vue&type=template&id=884cafe6&scoped=true&"
import script from "./NumberAnimation.vue?vue&type=script&lang=js&"
export * from "./NumberAnimation.vue?vue&type=script&lang=js&"
import style0 from "./NumberAnimation.vue?vue&type=style&index=0&id=884cafe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884cafe6",
  null
  
)

export default component.exports